export async function generateCopy(email, authToken, type) {
    if (type === 'generic-voice') {
        return await generateCopyWithVoice(email, authToken, type);
    }
    
    const response = await fetch('/generate-copy', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify({
            offer: localStorage.getItem('offer'),
            pain: localStorage.getItem('pain'),
            customer: localStorage.getItem('customer'),
            caseStudies: localStorage.getItem('caseStudies'),
            linkedInProfileUrl: localStorage.getItem('linkedInProfileUrl'),
            callToAction: localStorage.getItem('callToAction'),
            tone: localStorage.getItem('tone'),
            wordCount: localStorage.getItem('wordCount'),
            readingLevel: localStorage.getItem('readingLevel'),
            email,
            type
        }),
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const copy = await response.json();
    return copy;
};

export async function generateCopyWithVoice(email, authToken, type) {
    const response = await fetch('/generate-copy', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify({
            transcribedText: localStorage.getItem('transcribedText'),
            email,
            type
        }),
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const copy = await response.json();
    return copy;
}